import { ChangeDetectionStrategy, Component, computed, inject, input, viewChildren } from '@angular/core';
import { ProduktAttribute, TariffSelectionCardData } from '@mwe/models';
import { TariffSelectionCardCollapseItemComponent } from './tariff-selection-card-collapse-item.component';
import { TranslatePipe } from '@ngx-translate/core';
// eslint-disable-next-line
import { TariffSelectionStore } from '@mwe/ui/components';

@Component({
  selector: 'mwe-tariff-selection-card-back-ui',
  templateUrl: './tariff-selection-card-back-ui.component.html',
  imports: [TariffSelectionCardCollapseItemComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TariffSelectionCardBackUiComponent {
  private readonly tariffSelectionStore = inject(TariffSelectionStore);

  readonly selectedTariff = input.required<TariffSelectionCardData>();

  private readonly collapseItems = viewChildren(TariffSelectionCardCollapseItemComponent);

  readonly items = computed<ProduktAttribute[]>(() => this.selectedTariff()?.priceIndication?.preisbestandteile?.produktAttribute);
  readonly filteredItems = computed<ProduktAttribute[]>(() => {
    const items = this.items();
    const isTariffChangeEmobility = this.tariffSelectionStore.processType() === 'Tarifwechsel';

    if (isTariffChangeEmobility && items) {
      return items.filter(item => item.name !== 'Ladekarte einmalig');
    }

    return items;
  });

  onCollapseToggleClicked(): void {
    this.collapseItems().forEach(item => item.collapse());
  }
}
